export default __webpack_public_path__ + "plus.cf40167c199329ab.svg";